import { FaApple, FaAndroid } from "react-icons/fa";
export default function ReferenceAppDownload() { return (
      <section className="ref-app-download" id="app-download" aria-label="chorki app">
        <div className="ref-app-content">
          <img className="ref-app-illustration" src="/assets/bdtwin/chorki-app-art.png" alt="chorki mobile gaming artwork" />
          <div className="ref-app-instructions">
            <h2>chorki APP</h2>
            <p>1. Scan the QR code to open our website on your phone.</p>
            <p>2. Log in or register your account.</p>
            <p>3. Enjoy your favourite games.</p>
            <div className="ref-app-qr-cards">{["IOS", "Android"].map(platform => <a key={platform} href="https://chorki.win/" className="ref-app-qr"><img src="/assets/bdtwin/website-qr.png" alt={`Open chorki on ${platform}`} /><span>{platform === "IOS" ? <FaApple aria-hidden="true" /> : <FaAndroid aria-hidden="true" />} {platform}</span></a>)}</div>
            <p className="ref-app-fallback">If you failed to scan the QR code, you can also check our website on your browser</p>
            <p>IOS: <a href="https://chorki.win/">Open website</a><br />Android: <a href="https://chorki.win/">Open website</a></p>
          </div>
        </div>
      </section>
); }
